import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Tooltip from 'shopper/components/Tooltip';

const TIPS_BY_TAG = {
  parcelado: 'Você pode aproveitar essa oferta parcelando sem juros!',
  marketplace:
    'Essa oferta é vendida por terceiro mas foi verificada manualmente pela equipe Promobit.',
  internacional:
    'Essa oferta é enviada de fora do Brasil. Fique ligado em possíveis taxas adicionais e no prazo de entrega.',
  app: 'Aproveite a oferta somente no aplicativo da loja!',
  recorrente:
    'O valor dessa oferta é baseado no preço de assinatura recorrente na loja.',
  'primeira compra':
    'Valor só é atingido em caso de conta sem compras nessa loja.',
  'cliente ouro':
    'Programa de fidelidade do Magalu que dá ao cliente acesso a ofertas personalizadas, descontos e mais.',
  choice:
    'Esses produtos são selecionados, comprados e enviados diretamente pela Aliexpress e tem prazo de entrega reduzido.',
  magalupay:
    'O MagaluPay é a conta digital do Magalu. Te dá acesso a descontos e ofertas exclusivas.',
  'prime day': 'Evento com ofertas relâmpago e descontos incríveis da Amazon.',
  'amazon prime':
    'Serviço de assinatura da Amazon que oferece frete grátis e descontos exclusivos.',
  'prime ninja':
    'Serviço de assinatura da Kabum que dá direito a descontos exclusivos.',
  'frete grátis': 'Você não pagará nada para receber esse produto em casa!',
  'fast prime':
    'Serviço de assinatura da FastShop que oferece descontos exclusivos.',
  'vip casas bahia':
    'Programa gratuito da Casas Bahia que oferece ofertas exclusivas.',
  'pré-venda':
    'Desconto exclusivo de pré-venda. Prazo de entrega varia de acordo com a data de lançamento.',
  dlc: 'Essa oferta é um conteúdo adicional para jogos.',
  'ps plus essencial':
    'Serviço de assinatura que oferece jogos e descontos exclusivos para assinantes Playstation.',
  'membros adiclub':
    'Programa gratuito Adidas que dá direito a descontos exclusivos.',
  nacional:
    'Ofertas nacionais em lojas tradicionalmente internacionais, com prazo de entrega reduzido e taxas já inclusas.',
  'frete grátis*':
    'Essa oferta oferece frete grátis para algumas regiões, confira as regras no site da loja.',
  'taxa inclusa':
    'Os tributos de importação estão incluídos. Você não terá custos extras.',
};

const TooltipTag = ({ children, tagName, isFirst }) => {
  const tipMessage = TIPS_BY_TAG[tagName.toLowerCase()];

  if (!tipMessage) {
    return children;
  }

  return (
    <Tooltip.Root>
      <Tooltip.Trigger>{children}</Tooltip.Trigger>
      <Tooltip.Box
        align={isFirst ? 'left' : 'center'}
        className={twJoin('w-[200px]', isFirst && '-right-14 md:right-1/2')}
        size="size1"
      >
        {tipMessage}
      </Tooltip.Box>
    </Tooltip.Root>
  );
};

TooltipTag.propTypes = {
  children: PropTypes.node.isRequired,
  tagName: PropTypes.string.isRequired,
  isFirst: PropTypes.bool.isRequired,
};

export default TooltipTag;
